import { BytesSizeUnit } from '@philips-internal/oswald-ui-constants';
const BASE = 1024;
const units = [BytesSizeUnit.BYTES, BytesSizeUnit.KILOBYTES, BytesSizeUnit.MEGABYTES, BytesSizeUnit.GIGABYTES, BytesSizeUnit.TERABYTES];
/**
 * Converts a given byte size unit to another unit.
 *
 * @param size - The size to be converted, represented in the `from` unit;
 * @param from - The unit of the `size` parameter.
 * @param to - The unit to which the `size` parameter will be converted.
 *
 * @example
 * const sizeInKilobytes = convertFileSize(sizeInBytes, BytesSizeUnit.BYTES, BytesSizeUnit.KILOBYTES);
 *
 */
function convertBytesSize(size, from, to) {
    const fromIndex = units.indexOf(from);
    const toIndex = units.indexOf(to);
    const exponent = Math.abs(fromIndex - toIndex);
    // If the units are the same, return the original size
    let internalSize = size;
    if (fromIndex > toIndex) {
        internalSize = size * Math.pow(BASE, exponent);
    }
    if (fromIndex < toIndex) {
        internalSize = size / Math.pow(BASE, exponent);
    }
    return Number(internalSize.toFixed(2));
}
export { convertBytesSize, };
//# sourceMappingURL=convert-bytes-size.js.map